
import { getChildren } from "@/api/index.js"
import { message } from 'ant-design-vue';
// import _ from 'lodash'
//循环请求城市接口
export const cascadeEcho = (data) => {
  return new Promise(async resolve => {
    let node = {}
    for (let i = 0; i < data.length; i++) {
      const item = data[i];
      let res = await getChildren(item)
      if (res.length >= 1) {
        let data = res.map(item => {
          return {
            value: item.Id,
            label: item.Name,
            isLeaf: !item.bo,
            level: item.Level
          }
        })
        node[item] = data
      }
      if(i==data.length-1){
        resolve(node)
      }

    }

  })
};
//动态push城市
export const childrenEach = (options, list, node) => {
  if (options === undefined) return
  options.forEach(ele => {
    let key = list.find(item => Number(item) === Number(ele.value))
    if (key) {
      ele.children = node[Number(key)]
      childrenEach(ele.children, list, node)
    }
  })
}

//转换成select格式
export const getSelect = (node, label, value) => {
  let data = node.map(item => {
    return {
      value: item[value],
      label: item[label],
      isLeaf: false,
    }
  })
  return data
}

//对列 select下拉框赋可选数据
export const setSelectDicData = (columns, key, data) => {
  let list = _.cloneDeep(columns)
  let node = list.find(item => item.formKey === key)
  if (node) {
    node.dicData = data
  }

  return list
}





//表格修改
export const setTableEdit = (data, value, row, key) => {

}
//将数组改为对象
export const setTarget = (data, type) => {
  if (type === 'arr') {
    let obj = {}
    data.forEach(item => {
      obj[item.Name] = item.Value
    });
    return obj
  } else {
    let arr = []
    Object.keys(data).forEach(key => {
      arr.push({
        key,
        value: data[key]
      })
    })
    return arr
  }

}


//过滤children为null或者为空数组
export const treeFilter = (data) => {
  data.forEach((element) => {
    if (element.children && element.children.length > 0) {
      treeFilter(element.children)
    } else {
      delete element.children
    }
  })
  return data
}
export const getRandom = (n, m) => {
  var num = Math.floor(Math.random() * (m - n + 1) + n)
  return num
}
//接口弹窗提示
export function Msg(res) {
  if (res.success!==undefined) {
    if (res.success) message.success(res.msg||res.message||'操作成功')
    else message.error(res.msg||res.message||'操作失败')
  } else {
    if (res) message.success('操作成功')
    else message.error('操作失败')
  }

}

//数字转中文
export function SectionToChinese(num) {
  if (!/^\d*(\.\d*)?$/.test(num)) {
    return "Number is wrong!";
  }
  var AA = new Array("零", "一", "二", "三", "四", "五", "六", "七", "八", "九");
  var BB = new Array("", "十", "百", "千", "万", "亿", "点", "");
  var a = ("" + num).replace(/(^0*)/g, "").split("."),
    k = 0,
    re = "";
  for (var i = a[0].length - 1; i >= 0; i--) {
    switch (k) {
      case 0:
        re = BB[7] + re;
        break;
      case 4:
        if (!new RegExp("0{4}\\d{" + (a[0].length - i - 1) + "}$").test(a[0]))
          re = BB[4] + re;
        break;
      case 8:
        re = BB[5] + re;
        BB[7] = BB[5];
        k = 0;
        break;
    }
    if (k % 4 == 2 && a[0].charAt(i + 2) != 0 && a[0].charAt(i + 1) == 0) re = AA[0] + re;
    if (a[0].charAt(i) != 0) re = AA[a[0].charAt(i)] + BB[k % 4] + re;
    k++;
  }
  if (a.length > 1) //加上小数部分(如果有小数部分)
  {
    re += BB[6];
    for (var i = 0; i < a[1].length; i++) re += AA[a[1].charAt(i)];
  }
  return re;
}
// tag 唯一id
export function  genNonDuplicateID (){
  let idStr = Date.now().toString(36)
  idStr += Math.random().toString(36).substr(2)
  return idStr
}
//tag 导出
export function exportFile(data){
  // 使用atob方法解码base64
  var raw = window.atob(data.baseData);
  // 创建一个存储解码后数据的数组
  var uInt8Array = new Uint8Array(raw.length);
  // blob只能接收二进制编码，需要讲base64转为二进制再塞进去
  for (var i = 0; i < raw.length; ++i) {
      uInt8Array[i] = raw.charCodeAt(i);
  }
  // 这里给了一个返回值，在别的方法掉用传入base64编码就可以得到转化后的blob
  const link = document.createElement('a')
  const blob = new Blob([uInt8Array], { type: 'application/vnd.ms-excel' })
  link.style.display = 'none'
  link.href = URL.createObjectURL(blob)
  //设置下载的Excel表名
  link.setAttribute('download', `${data.excelName}`)  //要有文件名后缀，如.xslx
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}


//  合并单元格
export function combineRow(key,data) {
  let tableData = data
  for (var i = 0; i < tableData.length; i++) {
    const item = tableData[i]
    let count = 1
    for (let j = i + 1; j < tableData.length; j++) {
      // 如果是同一个值，往后递增
      if (item[key] === tableData[j][key]) {
        count++
        // 往后相同的值都设为空单元格
        tableData[j][`${key}RowSpan`] = 0
        // 只有同值第一个才设置合并的单元格数
        item[`${key}RowSpan`] = count
        // 所有都是为同一个值的情况
        // 如果到了尾部，则循环结束
        if (j === tableData.length - 1) {
            return
        }
      } else {
        // 指针跳转到下一个，从下一排开始
        i = j - 1
        count = 1
        tableData[j][`${key}RowSpan`] = 1
        break
      }
    }
  }
  return tableData
}


//将图片转为upload组件的格式
export const setImgList = (node) =>{
 let data = node.map(
      (item, index) => {
        return {
          uid: index,
          name: `图${index + 1}`,
          status: "done",
          url: `/store${item}`,
        };
      }
  );
  return data
}
//把数组图片转为后端所需要的数据
export const getImgString = (node,key = 'url') =>{
  let data = node.map((item) =>
    item.response ? item.response : item[key].replace("/store", "")
  );
  return data
}
export const screenPartner  = (key) =>{
  
  let partnerList =  [12001, 12002, 12003, 12004, 12005, 12006, 12007, 12008]
  let supplierList =  [14001, 14002, 14003, 14004, 14005, 14006, 14007, 14008]
  let value = 0
  if(partnerList.includes(key)){
    value = 0    
  }else if(supplierList.includes(key)){
    value = 1
  }
  return value
}


